export enum CalculationStage {
  WaitingForForm,
  LoadingResults,
  ResultsReady,
}

export default CalculationStage;
